import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycCanMakingAGiftBeforeApplyingToMedicaidSaveAssetsPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-can-making-a-gift-before-applying-to-medicaid-save-assets/']} />;
}
